function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["title", "description", "declaration"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useContext } from 'react';
import { LocaleContext } from "../locale";
import { Checkbox, Divider } from 'antd';
import omit from 'omit.js';
import formMethods from "../utils/form-methods";
import "./style";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var Declaration = function Declaration(_ref) {
  var title = _ref.title,
    description = _ref.description,
    declaration = _ref.declaration,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(LocaleContext),
    formatMessage = _useContext.formatMessage;
  return /*#__PURE__*/_jsxs("div", {
    className: "igloo-form-declaration",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "igloo-form-declaration-title",
      children: [title, title === undefined && formatMessage({
        id: 'Please take a moment to review what you’ve told us above.'
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "igloo-form-declaration-description",
      children: [description, description === undefined && formatMessage({
        id: 'Once you’re happy with the above, and you’ve checked the declaration, please go ahead and submit your claim.'
      })]
    }), /*#__PURE__*/_jsx(Divider, {
      className: "igloo-form-declaration-divider"
    }), /*#__PURE__*/_jsx(Checkbox, _objectSpread(_objectSpread({
      className: "igloo-form-declaration-declaration"
    }, omit(rest, formMethods)), {}, {
      children: declaration || formatMessage({
        id: 'I declare that the statements I have described above are true. I further declare that the loss occured was accidental, without planning or consensus with other parties.'
      })
    }))]
  });
};
Declaration.formItemPropsHandler = function (config) {
  var rules = [];
  // 用户没有明确指明 `required: false`时，需要加上验证
  if (config.required !== false) {
    var _config$requiredMessa;
    var requiredMessage = (_config$requiredMessa = config.requiredMessage) !== null && _config$requiredMessa !== void 0 ? _config$requiredMessa : 'Please check the declaration to proceed.';
    rules.push({
      validator: function validator(_, value) {
        return new Promise(function (resolve, reject) {
          if (!value) {
            return reject(new Error(requiredMessage));
          }
          return resolve('ok');
        });
      }
    });
  }
  return {
    getValueFromEvent: function getValueFromEvent(e) {
      return e.target.checked;
    },
    valuePropName: 'checked',
    fullRow: true,
    required: false,
    rules: rules
  };
};
export default Declaration;